import { render, staticRenderFns } from "./importOrder.vue?vue&type=template&id=2aa9c592&scoped=true"
import script from "./importOrder.vue?vue&type=script&lang=js"
export * from "./importOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa9c592",
  null
  
)

export default component.exports